import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  footer: {
    width: "100%",
    textAlign: "center",
    position: "relative",
    backgroundColor: theme.palette.background.default,
   
  },
  footerAB: {
    width: "100%",
    textAlign: "center",
   
  },
  button: {
    marginBottom: 20,
    width: 432,
    height: 78,
    fontSize: 20,
    [theme.breakpoints.down("lg")]: {
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("md")]: {
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: 300,
      height: 56,
      fontSize: 18,
    },
  },
}));

const CancerMainFooter = ({ name1 = "다음으로", onClick1 }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      className={classes.footer}
    >
      <Grid className={classes.footerAB}>
        <Button
          onClick={onClick1}
          variant="contained"
          color="primary"
          className={classes.button}
        >
          {name1}
        </Button>
      </Grid>
    </Grid>
  );
};

export default CancerMainFooter;
